import { Dialog, DialogContent } from "@workspace/frontend-ui";

type Props = {
  onClose: () => void;
  header: React.JSX.Element;
};

const DesktopDialog: FC<Props> = ({ onClose, children, header }) => (
  <Dialog onOpenChange={onClose} open aria-describedby={undefined}>
    <DialogContent
      className="max-w-md bg-background rounded-2xl gap-0"
      showCloseButton={false}
    >
      {header}
      {children}
    </DialogContent>
  </Dialog>
);

export default DesktopDialog;
